import { DoneAll, OpenInNew, Close } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Drawer,
  IconButton,
  List,
  Stack,
  Typography,
  Button,
  Divider,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllNotifications, markAllRead } from '../../modules/notification';
import NotificationItem from './NotificationItem';

const NAV_HEIGHT = 64;

const NotificationsDrawer = ({
  open,
  onClose,
  notifications,
  totalUnRead,
  loading,
  fetchNotifications,
}) => {
  const navigate = useNavigate();

  const handleMarkAllRead = async () => {
    try {
      await markAllRead();
      fetchNotifications();
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleClearAll = async () => {
    try {
      await clearAllNotifications();
      fetchNotifications();
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleViewAll = () => {
    onClose();
    navigate('/notifications');
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{ BackdropProps: { invisible: true } }}
      PaperProps={{
        sx: {
          width: 420,
          top: `${NAV_HEIGHT}px`,
          height: `calc(100% - ${NAV_HEIGHT}px)`,
          display: 'flex',
          flexDirection: 'column',
          borderLeft: '1px solid #ddd',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2.5,
          py: 2,
          flexShrink: 0,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Notifications
        </Typography>

        <Stack direction="row" alignItems="center" spacing={0.5}>
          {totalUnRead > 0 && (
            <IconButton size="small" title="Mark all as read" onClick={handleMarkAllRead}>
              <DoneAll fontSize="small" />
            </IconButton>
          )}
          {notifications?.length > 0 && (
            <>
              <IconButton size="small" title="View all" onClick={handleViewAll}>
                <OpenInNew fontSize="small" />
              </IconButton>
              <Button
                size="small"
                variant="text"
                color="inherit"
                onClick={handleClearAll}
                disableRipple
                sx={{ fontSize: 13 }}
              >
                Clear all
              </Button>
            </>
          )}
          <IconButton size="small" onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        </Stack>
      </Box>

      <Divider />

      <Box sx={{ flex: 1, overflowY: 'auto', px: 1 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress size={24} />
          </Box>
        ) : notifications.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography variant="body2" color="text.secondary">
              You have no new notifications.
            </Typography>
          </Box>
        ) : (
          <List disablePadding>
            {notifications.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                fetchNotifications={fetchNotifications}
              />
            ))}
          </List>
        )}
      </Box>

      {notifications.length > 0 && (
        <>
          <Divider />
          <Box sx={{ px: 2.5, py: 1.5, flexShrink: 0 }}>
            <Button
              fullWidth
              variant="text"
              onClick={handleViewAll}
              endIcon={<OpenInNew fontSize="small" />}
              sx={{ justifyContent: 'center', fontSize: 13 }}
            >
              View all notifications
            </Button>
          </Box>
        </>
      )}
    </Drawer>
  );
};

export default NotificationsDrawer;